import { api } from './client.js';

// Update the signed-in user's own profile (name, email, phone, location).
export const updateProfile = (body) => api.patch('/me/profile', body).then((r) => r.data.user);

// Clients a rep may act on behalf of.
export const fetchRepClients = () => api.get('/me/clients').then((r) => r.data.clients);

// A rep's book: assigned companies with client logins + the rep's own order stats.
export const fetchRepBook = () => api.get('/me/book').then((r) => r.data.companies);

// Company-location shipping address (view + edit → writes back to Shopify). scope = {} for a client
// (their own location), or { store, companyLocationId } for a rep/staff acting on a client.
export const fetchShippingAddress = (scope) => api.get('/me/shipping-address', { params: scope || {} }).then((r) => r.data);
export const updateShippingAddress = (scope, address) =>
  api.put('/me/shipping-address', { ...(scope || {}), address }).then((r) => r.data);

// The stores this client login may order for (one, unless they're a head-office buyer).
export const fetchMyLocations = () => api.get('/me/locations').then((r) => r.data.locations);
// A client's own account-hold status (client-safe wording): { onHold, message?, overdue? }.
export const fetchMyCredit = () => api.get('/me/credit').then((r) => r.data);
// Hold status of the client location a rep/staff member is ordering for.
export const fetchLocationCredit = (companyLocationId) => api.get('/me/location-credit', { params: { companyLocationId } }).then((r) => r.data);
// Statement PDF for one of the rep's clients (a plain link — the browser sends the auth cookie).
export const clientStatementUrl = (companyId) => `/api/me/clients/${companyId}/statement.pdf`;

// A client's promotions (live + upcoming): { currency, promotions: [{ name, type, percent, tiers, status, startsAt, endsAt, ... }] }.
export const fetchMyPromotions = () => api.get('/me/promotions').then((r) => r.data);

// The client home page (restock, rhythm, categories, new, online best sellers, account manager).
export const fetchMyHome = () => api.get('/me/home').then((r) => r.data);
// Staff/rep preview of a client's home page, and that client's promotions.
export const fetchClientHomePreview = (companyId) => api.get(`/me/clients/${companyId}/home`).then((r) => r.data);
export const fetchClientPromotions = (companyId) => api.get(`/me/clients/${companyId}/promotions`).then((r) => r.data);

// The rep home: commission this month + on its way, who to call today, promotions, what to pitch.
// Staff pass repId to see exactly what that rep sees.
export const fetchRepHome = (repId) => api.get('/me/rep-home', { params: repId ? { repId } : {} }).then((r) => r.data);
